/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement, ReactNode } from 'react';
import { styled } from 'styled-components';

interface ButtonContainerProps {
    children: ReactNode;
}

export default function ButtonContainer({
    children,
}: ButtonContainerProps): ReactElement {
    return <FlexWithSpaceBetween>{children}</FlexWithSpaceBetween>;
}

const FlexWithSpaceBetween = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin: 30px 0 0;
    @media (max-width: 500px) {
        justify-content: space-between;
    }
`;
